module.exports = __webpack_public_path__ + "img/flag-en.7eaf3e90.png";